import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ShortcutCard } from "../shortcuts/ShortcutCard";
import { obtenerMatrizPromociones } from "../AccionesBackend";
import {BotonRegresar} from "../BotonRegresar";

export const MatricesPromociones = () => {
    const [matrizPromociones, setMatrizPromociones] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchMatrizPromociones = async () => {
            try {
                const result = await obtenerMatrizPromociones();
                if (result.success && result.matrizPromociones) {
                    // Secciones permitidas
                    const allowedSections = [23, 24, 25, 26];
                    // Filtrar las promociones por seccion_id permitida
                    const promocionesFiltradas = result.matrizPromociones.filter((promocion) =>
                        allowedSections.includes(Number(promocion.seccion_id))
                    );
                    // Deduplicar por seccion_id (usar la primera ocurrencia)
                    const uniquePromosMap = new Map();
                    promocionesFiltradas.forEach((promo) => {
                        if (!uniquePromosMap.has(promo.seccion_id)) {
                            uniquePromosMap.set(promo.seccion_id, promo);
                        }
                    });
                    const uniquePromos = Array.from(uniquePromosMap.values());

                    // Transformar los datos para que coincidan con ShortcutCard
                    const promocionesTransformadas = uniquePromos.map((promocion) => ({
                        seccion_id: promocion.seccion_id,
                        title: promocion.marca,
                        description: `Promociones de ${promocion.marca}`,
                        imgUrl: null, // Dejamos solo texto (el fallback de ShortcutCard mostrará la inicial)
                        backgroundColor: "rgba(188,43,108,0.52)",
                        textColor: "rgb(255, 255, 255)",
                        url: `/matriz-de-promociones/${promocion.marca}`,
                        comentarios: promocion.canales_aplica,
                    }));

                    setMatrizPromociones(promocionesTransformadas);
                } else {
                    setError("No se pudo obtener la información");
                }
            } catch (err) {
                console.error("Error al obtener la matriz de promociones:", err);
                setError("Error al obtener la matriz de promociones");
            } finally {
                setLoading(false);
            }
        };

        fetchMatrizPromociones();
    }, []);

    if (loading) {
        return <p>Cargando matriz de promociones...</p>;
    }

    if (error) {
        return <p>{error}</p>;
    }

    return (
        <section className="shortcut-marketing" id="shortcut-marketing">
            <Container>
                <div className="banner-transparente">
                    <BotonRegresar/>
                    <h1 className="banner-title">Matriz de promociones</h1>
                    <p className="banner-description">Descubre nuestras promociones y ofertas exclusivas.</p>
                </div>
                <Row className="justify-content-center pb-5">
                    {matrizPromociones.map((promo) => (
                        <Col key={promo.seccion_id} xs={6} sm={3} md={3} lg={3}>
                            <ShortcutCard
                                {...promo}
                            />
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};